import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Combobox } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { removeVI } from 'jsrmvi';
import { IoIosSearch } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { RootState } from 'app/store';
import { routes, RouteProps } from '@lib/routes';

const SearchAnimation: any = styled.div`
  position: relative;
  .show-input {
    width: 14rem !important;
  }
  input {
    -webkit-transition: width 0.32s ease-in-out;
    -moz-transition: width 0.32s ease-in-out;
    -o-transition: width 0.32s ease-in-out;
    transition: width 0.32s ease-in-out;
    &:focus {
      width: 14rem !important;
    }
  }
`;

export default function DropdownResultSearch() {
  const { t } = useTranslation();
  const [selectedFunction, setSelectedFunction] = useState<any>();
  const [query, setQuery] = useState('');
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const history = useNavigate();
  // Selector
  // const routeData = useSelector((state: RootState) => state.user.routeData);
  const account = useSelector((state: RootState) => state.user.account);
  const routesFilter = useSelector((state: RootState) => state.user.routesFilter); // list menu theo role
  const renderMenuItem = (routeC: RouteProps | any) => {
    // console.log('routeC', routeC.key, routes);

    if (routeC.hiddenSider || (routesFilter && routesFilter.includes(routeC.key))) {
      return null;
    }
    return routeC;
  };

  const functionData = useMemo(() => {
    if (routes) {
      const result: any = [];
      routes.map(route => {
        if (route.hiddenSider || routesFilter.includes(route.key)) {
          return null;
        }
        return (
          route.children &&
          route.children.map(e => {
            if (renderMenuItem(e) !== null) result.push(renderMenuItem(e));
          })
        );
      });
      return result;
    }
  }, [routes]);

  const filteredMenu = useMemo(() => {
    return query === ''
      ? functionData
      : [...functionData].filter((item: any) => {
          return removeVI(t(item.title)).toLowerCase().includes(removeVI(query).toLowerCase());
        });
  }, [query]);

  useEffect(() => {
    if (selectedFunction) {
      handleClickSearchMenuItem(selectedFunction.pathSub ? selectedFunction.pathSub : selectedFunction.path);
    }
  }, [selectedFunction]);

  const handleClickSearchMenuItem = (path: any) => {
    history(`/${path.url}`);
  };

  const handleClickIconSearch = useCallback((e: any) => {
    const InputHtml = document.querySelector('.search-animation-input') as HTMLElement | null;
    if (InputHtml?.classList.contains('show-input')) {
      // console.log('đã có show');
      InputHtml?.classList.remove('show-input');
      setShowSearch(false);
      return;
    }
    setShowSearch(true);
    // console.log('chưa có show');
    InputHtml.focus();
    InputHtml?.classList.add('show-input');
  }, []);
  return (
    // onChange={setSelectedFunction} value={selectedFunction}
    <Combobox>
      <div className="relative ">
        <SearchAnimation>
          <div className="absolute top-1 right-[0.01rem] cursor-pointer" onClick={handleClickIconSearch}>
            <IoIosSearch className="w-7 h-7 hover:text-blue-500 text-gray-500" />
          </div>

          <Combobox.Input
            className={
              'search-animation-input w-8 bg-white text-black flex rounded-full h-8 px-2 py-2 2xl:text-base md:text-sm lg:text-sm outline-none'
            }
            placeholder={showSearch ? t('Header.SearchBar.Placeholder') : ''}
            onChange={event => setQuery(event.target.value)}
          />
        </SearchAnimation>

        <Combobox.Options className="text-black z-20 absolute mt-[1rem] max-h-60 w-full overflow-auto rounded-md bg-white py-2 text-base shadow-lg focus:outline-none sm:text-sm">
          {filteredMenu.length !== 0 &&
            filteredMenu.map((item: any, index: number) => (
              <Combobox.Option
                onClick={() => history(`${item.url}`)}
                key={index}
                value={item}
                className="py-2 cursor-pointer hover:bg-gray-200 px-2"
              >
                {t(item.title)}
              </Combobox.Option>
            ))}
          {filteredMenu.length === 0 && (
            <div className="text-center py-4 text-black">{t('Header.SearchBar.NoDataSearch')}</div>
          )}
        </Combobox.Options>
      </div>
    </Combobox>
  );
}
